import Base from '../base';

const PERCENTAGE_DEFAULT = 50;
const PLACEHOLDER_EMPTY_VALUE = '–';
const LABEL_EMPTY_DEFAULT = 'No data yetsst';

const hasOption = (options, property) => options.hasOwnProperty(property) && options[property] !== '';

const optionOrDefault = (options, property, fallback) => (hasOption(options, property)
	? options[property]
	: fallback);

class UnderlyingSentiment extends Base {
	start() {
		const innerHTML = this.getInnerHTML();

		this.render(innerHTML);
	}

	getInnerHTML() {
		const { options } = this;

		const hasValue = hasOption(options, 'bull');

		const innerHTML = hasValue
			? UnderlyingSentiment.getBarsHTML(options)
			: UnderlyingSentiment.getNoDataHTML(options.labelEmpty);

		return innerHTML;
	}

	static getBarsHTML(options) {
		const bullWidthPercentage = optionOrDefault(options, 'bull', PERCENTAGE_DEFAULT);
		const bullValuePercentage = optionOrDefault(options, 'bull', PLACEHOLDER_EMPTY_VALUE);

		const bearWidthPercentage = optionOrDefault(options, 'bear', PERCENTAGE_DEFAULT);
		const bearValuePercentage = optionOrDefault(options, 'bear', PLACEHOLDER_EMPTY_VALUE);

		const bars = [
			{
				width: bullWidthPercentage,
				value: bullValuePercentage,
				sentimentClass: 'is-bull',
			},
			{
				width: bearWidthPercentage,
				value: bearValuePercentage,
				sentimentClass: 'is-bear',
			},
		];

		return bars.reduce(
			(html, { width, value, sentimentClass }) => `
			${html}
				<div class= "underlying-sentiment__bar ${sentimentClass}" style="width: ${width}%">
					<span class="underlying-sentiment__value">
						${value}%
					</div>
				</div >
			`,
			'',
		);
	}

	static getNoDataHTML(label = LABEL_EMPTY_DEFAULT) {
		return `<div class="underlying__sentiment-empty">${label}</div>`;
	}

	render(html) {
		this.el.innerHTML = html;
	}
}

export default UnderlyingSentiment;
